import { render, staticRenderFns } from "./ImpuestosAdicionalesFields.vue?vue&type=template&id=3bed9e60&"
import script from "./ImpuestosAdicionalesFields.vue?vue&type=script&lang=js&"
export * from "./ImpuestosAdicionalesFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
